import './Home.css'
import { Typography, Box } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import data from './InternationalEvents.json'

const IELogo = () => {
  return (
    <>
      {data.map((item: any, index: number) => (
        <a
          data-gtm-click-subsection2={item.alt}
          className='ie-a'
          href={item.url}
          target='_blank'
          rel='noopener noreferrer'
          key={index}
        >
          <img src={item.src} alt={item.alt} style={{ width: item?.width + 'px' }} />
        </a>
      ))}
    </>
  )
}

export default function InternationalEvents() {
  return (
    <Box sx={{ px: 0, py: { xs: 6, sm: 8 }, bgcolor: '#222' }}>
      <Box px={2}>
        <Typography variant='h2' mb={5}>
          <FormattedMessage id='home.internationalEvents.title' />
        </Typography>
      </Box>
      <div className='ie-scroll-container'>
        <div
          data-gtm-click-section='Home'
          data-gtm-click-subsection1='International Events'
          className='ie-image-wrapper'
        >
          <IELogo />
          {/* Copy of images for infinite effect */}
          <IELogo />
        </div>
      </div>
    </Box>
  )
}
